import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {
  static targets = [ "cardInput", "errors", "total", "tax", "taxAmount", "stripeTokenHiddenInput",
                     "zipHidden", "submit" ]

  connect() {
    this.stripe = Stripe(this.data.get("stripe-key"))
    this.card = this.stripe.elements().create('card')
    this.card.mount(this.cardInputTarget)
    this.card.addEventListener('change', this.cardInputChanged.bind(this))
  }

  cardInputChanged(event) {
    let zip = event.value.postalCode
    if (zip) {
      this.zipHiddenTarget.value = zip
      this.updateForTax(this.isTaxableZip(zip))
    }
  }

  updateForTax(addTax) {
    if (addTax) {
      this.totalTarget.innerText = this.data.get("total-with-tax")
      this.show('tax')
    } else {
      this.totalTarget.innerText = this.data.get("net-amount")
      this.hide('tax')
    }
  }

  validateForm(event) {
    const $this = this;
    setTimeout(function() {
      const submitBtn = document.getElementById("submit-checkout-btn");
      const target = submitBtn.dataset.target
      if (target !== 'null') {
        $this.submitForm(event);
      }
    }, 500);
  }

  async submitForm(event) {
    this.element.classList.add("loading")
    let result = await this.stripe.createToken(this.card)
    if (result.error) {
      this.element.classList.remove("loading")
      this.errorsTarget.textContent = result.error.message
    } else {
      this.stripeTokenHiddenInputTarget.value = result.token.id
      this.submitTarget.click()
    }
  }

  isTaxableZip(zip) {
    let md = zip.match(/^(\d{3})\d{2}$/)
    let prefix = md && md[1]
    return (prefix >= 100 && prefix <= 149) || prefix == "005" || prefix == "063"
  }
}
